import { Eye } from "lucide-react";
import { SpecialtyPage } from "@/components/SpecialtyPage";

const procedures = [
  { nameKey: "specialties.vision.procedure1Name", descriptionKey: "specialties.vision.procedure1Desc", durationKey: "specialties.vision.procedure1Duration", recoveryKey: "specialties.vision.procedure1Recovery" },
  { nameKey: "specialties.vision.procedure2Name", descriptionKey: "specialties.vision.procedure2Desc", durationKey: "specialties.vision.procedure2Duration", recoveryKey: "specialties.vision.procedure2Recovery" },
  { nameKey: "specialties.vision.procedure3Name", descriptionKey: "specialties.vision.procedure3Desc", durationKey: "specialties.vision.procedure3Duration", recoveryKey: "specialties.vision.procedure3Recovery" },
];
const faq = [
  { questionKey: "specialties.vision.faq1Q", answerKey: "specialties.vision.faq1A" },
  { questionKey: "specialties.vision.faq2Q", answerKey: "specialties.vision.faq2A" },
  { questionKey: "specialties.vision.faq3Q", answerKey: "specialties.vision.faq3A" },
  { questionKey: "specialties.vision.faq4Q", answerKey: "specialties.vision.faq4A" },
  { questionKey: "specialties.vision.faq5Q", answerKey: "specialties.vision.faq5A" },
];

export default function VisionCorrection() {
  return (
    <SpecialtyPage
      icon={Eye}
      titleKey="specialties.vision.title"
      subtitleKey="specialties.vision.subtitle"
      overviewKey="specialties.vision.overview"
      procedures={procedures}
      advantagesKeys={["specialties.vision.advantage1", "specialties.vision.advantage2", "specialties.vision.advantage3"]}
      faq={faq}
      priceFromKey="specialties.vision.priceFrom"
      priceNoteKey="specialties.vision.priceNote"
      comparisonKey="specialties.vision.comparison"
      ctaTitleKey="specialties.vision.ctaTitle"
    />
  );
}
